// Central config for all available plans and their display details
// The order of the plans determines the button as 'upgrade' or 'buy'

const PLAN_CONFIG = [
  {
    id: "free",
    nameKey: "plan_free_name",
    price: "CAD 0.00 / month",
    "weight": 10,
    features: [
      "plan_free_feature1",
      "plan_free_feature2"
    ]
  },
  {
    id: "manual_260515",
    nameKey: "plan_manual_260515_name",
    price: "Manually paid in advance",
    "weight": 20,
    features: [
      "plan_basic_feature1",
      "plan_basic_feature2",
      "plan_basic_feature5"
    ]
  },
  {
    id: "basic",
    nameKey: "plan_basic_name",
    monthly: {
      id: "basic",
      price: "CAD 14.99 / month",
      "weight": 30,
      features: [
        "plan_basic_feature1",
        "plan_basic_feature2",
        "plan_basic_feature5"
      ]
    },
    annual: {
      id: "basic_annual",
      price: "CAD 159.99 / year (save 10%)",
      "weight": 40,
      features: [
        "plan_basic_feature1",
        "plan_basic_feature2",
        "plan_basic_feature5"
      ]
    }
  },
  {
    id: "manual_260610",
    nameKey: "plan_manual_260610_name",
    price: "Manually paid in advance",
    "weight": 47,
    features: [
      "plan_premium_feature1",
      "plan_premium_feature2",
      "plan_premium_feature5"
    ]
  },
  {
    id: "premium",
    nameKey: "plan_premium_name",
    monthly: {
      id: "premium",
      price: "CAD 23.99 / month",
      "weight": 50,
      features: [
        "plan_premium_feature1",
        "plan_premium_feature2",
        "plan_premium_feature5"
      ]
    },
    annual: {
      id: "premium_annual",
      price: "CAD 259.99 / year (save 10%)",
      "weight": 60,
      features: [
        "plan_premium_feature1",
        "plan_premium_feature2",
        "plan_premium_feature5"
      ]
    }
  }
];

export default PLAN_CONFIG;
